module.exports = __webpack_public_path__ + "static/img/login_username.2103dcb.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/login_username.svg
// module id = rxe0
// module chunks = 3